import { useEffectOnFirstMount } from "@/lib/common/useEffectOnFirstMount";
import { useQueryParams } from "@/lib/common/useQueryParams";
import { useAuthState } from "@/lib/state";
import { useEffect, type FC } from "react";
import { useNavigate } from "react-router";

export const PageIndex: FC = () => {
	const { state, dispatchAuthSetAttribution } = useAuthState();
	const navigate = useNavigate();
	const queryParams = useQueryParams();
	const attribution = queryParams.get("attr");

	useEffect(() => {
		if (attribution) {
			dispatchAuthSetAttribution(attribution);
		}
	}, [attribution]);

	useEffectOnFirstMount(() => {
		if (state.accessToken) {
			navigate("dashboard", { replace: true });
			return;
		}

		navigate("login", { replace: true });
	});

	return <></>;
};
